import React from "react";
import PropTypes from "prop-types";
import UsageIndicatorContainer from "./styles/UsageIndicator.style";

const UsageIndicator = ({ video, videoPreview }) => {
  let clearanceMessage = "";
  let iconColor = "";
  let eMessage = "Digital / Clip Show Use";
  let eMessageIconColor = "green";
  let aMessage = "";
  const clearanceStatus = video?.clearanceStatus;

  if (video.aci === "YELLOW") {
    aMessage = "Inquire for Advertising Use";
    iconColor = "yellow";
    if (clearanceStatus === "LIMITATIONS") {
      eMessage = "Inquire for Digital/Clip Show Use";
      eMessageIconColor = "yellow";
    }
  } else if (video.aci === "GREEN") {
    if (clearanceStatus === "FEATURED") {
      aMessage = "Inquire for further details on available talent releases.";
    } else {
      aMessage = "Advertising Use";
      clearanceMessage = "Talent releases on file for all on-camera participants.";
    }
    iconColor = "green";
  } else if (video.aci === "RED") {
    aMessage = "Not for Advertising Use";
    iconColor = "red";
  }
  return (
    <UsageIndicatorContainer>
      <div className="clearance--status">
        {!videoPreview && <span className="message">Clearance Status: </span>}
      </div>

      <div className="clearance--status">
        <span className={`dot use-icon ${eMessageIconColor}`} />
        <span className="message">{eMessage}</span>
      </div>

      <div className="clearance--status">
        <span className="dot use-icon yellow" />
        <span className="message">Inquire for Trademark, Music &amp; Other Third-Party Rights</span>
      </div>

      <div className="clearance--status">
        <span className={`dot use-icon ${iconColor}`} />
        <span className="message">{aMessage}</span>
      </div>

      {video.aci === "GREEN" && (
        <div className="clearance--status">
          <span className="clearance-message">{clearanceMessage}</span>
        </div>
      )}
    </UsageIndicatorContainer>
  );
};

UsageIndicator.propTypes = {
  video: PropTypes.shape().isRequired
};

export default UsageIndicator;
